import { render, staticRenderFns } from "./section-title.vue?vue&type=template&id=c3407ce0&scoped=true&"
import script from "./section-title.vue?vue&type=script&lang=js&"
export * from "./section-title.vue?vue&type=script&lang=js&"
import style0 from "./section-title.vue?vue&type=style&index=0&id=c3407ce0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3407ce0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3407ce0')) {
      api.createRecord('c3407ce0', component.options)
    } else {
      api.reload('c3407ce0', component.options)
    }
    module.hot.accept("./section-title.vue?vue&type=template&id=c3407ce0&scoped=true&", function () {
      api.rerender('c3407ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/section-title.vue"
export default component.exports